import * as z from "zod";
import { mutator } from "./mutator";

export const setSidebarCollapsed = mutator({
  schema: z.object({
    surface: z.string().max(32),
    collapsed: z.boolean(),
  }),
  resolve: {},
  permissions: {
    none: "records a preference that never leaves the caller’s browser",
  },
  description:
    "Triggered when a user collapses or expands the sidebar or its discoverable spaces list.",
  interactionType: "update",
  fn: async () => {},
});
